import { format } from 'date-fns'
import { useAuthStore } from '@/stores/auth'
import { useGet } from './useFetch'
import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { useSupplierClinics } from './useSupplierClinics'

export interface SupplierReportStats {
  summary: {
    totalPlays: number
    totalPeople: number
    clinicCount: number
  }
  adStats: Array<{
    adId: number
    adTitle: string
    playCount: number
    deviceCount: number
    startDate: string | null
    endDate: string | null
  }>
  clinicStats: Array<{
    clinicId: number
    clinicName: string
    playCount: number
    peopleCount: number
  }>
}

interface UseSupplierClinicStatsParams {
  supplierId: number
  startDate?: Date
  endDate?: Date
  adId?: number
}

export const useSupplierClinicStats = ({
  supplierId,
  startDate,
  endDate,
  adId,
}: UseSupplierClinicStatsParams) => {
  const { token } = useAuthStore()

  // 獲取供應商關聯的診所列表
  const { clinics, isLoading: isClinicsLoading } = useSupplierClinics({ supplierId })

  const queryParams = new URLSearchParams()
  if (startDate) {
    queryParams.append('startDate', format(startDate, 'yyyy-MM-dd'))
  }
  if (endDate) {
    queryParams.append('endDate', format(endDate, 'yyyy-MM-dd'))
  }
  if (adId) {
    queryParams.append('adId', String(adId))
  }

  const url = `/api/ad-suppliers/${supplierId}/report?${queryParams.toString()}`

  const {
    data,
    error,
    isLoading: isStatsLoading,
    mutate,
  } = useGet<ApiResponse<SupplierReportStats>>(
    token && supplierId ? url : null,
    undefined,
    token ?? '',
  )

  return {
    stats: data?.data,
    clinics, // 新增：供應商關聯的診所列表
    isLoading: isStatsLoading || isClinicsLoading,
    isError: error,
    mutate,
  }
}
